import React, { useState, useRef, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const EmailTagInput = ({
  name,
  register,
  setValue,
  rules = {},
  initialValue = "",
  disable,
  onEmailsChange
}) => {
  const [inputValue, setInputValue] = useState('');
  const [tagError, setTagError] = useState('');
  const [emails, setEmails] = useState(() => {
    if (!initialValue) return [];
    return initialValue
      .split(',')
      .map(email => email.trim())
      .filter(email => email.length > 0 && EMAIL_REGEX.test(email));
  });
  const inputRef = useRef(null);

  useEffect(() => {
    if (register) {
      register(name, rules);
    }
  }, [register, name, rules]);


  useEffect(() => {
    const emailString = emails.join(',');
    if (onEmailsChange) {
      onEmailsChange(emailString);
    }
    else if (setValue) {
      setValue(name, emailString, { shouldValidate: true, shouldDirty: true });
    }
  }, [emails, onEmailsChange, setValue, name, tagError]);

  const validateAndAddEmail = useCallback((email) => {
    email = email.trim();

    if (!email || disable) return;

    if (!EMAIL_REGEX.test(email)) {
      setTagError(`"${email}" is not a valid email address.`);
      return;
    }
    if (emails.includes(email)) {
      setTagError(`"${email}" is already added.`);
      return;
    }

    setEmails((prevEmails) => [...prevEmails, email]);
    setInputValue('');
    setTagError('');
  }, [emails, disable]);

  const handleKeyDown = (e) => {
    if (disable) return;
    if (tagError) setTagError('');
    if (e.key === 'Enter' || e.key === ',' || e.key === 'Tab') {
      e.preventDefault();
      validateAndAddEmail(inputValue);
    }
    else if (e.key === 'Backspace' && inputValue === '' && emails.length > 0) {
      removeEmail(emails.at(-1));
    } else {
      setTagError('');
    }
  };

  const removeEmail = (emailToRemove) => {
    if (disable) return;
    setEmails(emails.filter(email => email !== emailToRemove));
    inputRef.current.focus();
  };

  return (
    <div className="email-tag-container">
      <p>
        Config. Value <span style={{ color: "red" }}>*</span>
      </p>
      <div className={`tag-input-box ${disable ? 'disabled-tag-input' : ''}`}>
        {emails.map((email) => (
          <span key={email.id} className="email-tag">
            {email}
            {!disable && (
              <button
                type="button"
                className="remove-tag-btn"
                onClick={() => removeEmail(email)}
                title={`Remove ${email}`}
                disabled={disable}
              >
                &times;
              </button>
            )}
          </span>
        ))}

        <input
          ref={inputRef}
          className="input-field-tag"
          type="text"
          value={inputValue}
          onChange={(e) => {
            setInputValue(e.target.value);
            if (tagError) setTagError('');
          }}
          onBlur={() => validateAndAddEmail(inputValue)}
          onKeyDown={handleKeyDown}
          placeholder={emails.length === 0 ? "Add key emails..." : ""}
          disabled={disable}
        />
      </div>
    </div>
  );
};

EmailTagInput.propTypes = {
  name: PropTypes.string.isRequired,
  register: PropTypes.func,
  setValue: PropTypes.func,
  rules: PropTypes.object,
  initialValue: PropTypes.string,
  disable: PropTypes.bool,
  onEmailsChange: PropTypes.func
};

export default EmailTagInput;